export enum CoenergyUserRole {
  Admin = 'admin',
  Commercial = 'commercial',
  Engineering = 'engineering',
  Finance = 'finance',
  Readonly = 'readonly',
  Partner = 'partner',
}

export const coenergyUserRoleLabels: Record<CoenergyUserRole, string> = {
  [CoenergyUserRole.Admin]: 'Administrador',
  [CoenergyUserRole.Commercial]: 'Comercial',
  [CoenergyUserRole.Engineering]: 'Engenharia',
  [CoenergyUserRole.Finance]: 'Financeiro',
  [CoenergyUserRole.Readonly]: 'Somente leitura',
  [CoenergyUserRole.Partner]: 'Parceiro',
};

export const staffRoles: CoenergyUserRole[] = [
  CoenergyUserRole.Admin,
  CoenergyUserRole.Commercial,
  CoenergyUserRole.Engineering,
  CoenergyUserRole.Finance,
  CoenergyUserRole.Readonly,
];

export const isPartnerRole = (role: CoenergyUserRole) =>
  role === CoenergyUserRole.Partner;
